import React from 'react'

const Brands = () => {
    return (
        <div>
            in brands
        </div>
    )
}

export default Brands
